// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VCharts from "v-charts";
import axios from "./axios/http";
import "./style/gloable.scss";

Vue.use(ElementUI);
Vue.use(VCharts);
var VueCookie = require("vue-cookie");
Vue.use(VueCookie);
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false;

axios
  .post("data/getAuth", getParams())
  .then(res => {
    console.log(res);
    if (res.status === 200) {
      console.log(res.data.Authorization);
      if (res.data.code !== 500) {
        Vue.cookie.set("Authorization", res.data.Authorization);
      } else {
        if (Vue.cookie.get("Authorization").length === 0) {
          window.location.href = 'http://mnbinggui.mengniu.com.cn/web/login'
        }
      }
      axios.defaults.headers.common['Authorization'] = Vue.cookie.get(
        "Authorization"
      );
      new Vue({
        el: "#app",
        router,
        components: { App },
        template: "<App/>"
      });
    } else {
      // window.location.href = 'http://mnbinggui.mengniu.com.cn/web/login'
    }
  })
  .catch(res => {
    // window.location.href = 'http://mnbinggui.mengniu.com.cn/web/login'
  });
function getParams() {
  var obj = {};
  // if (Vue.cookie.get("Authorization")) {
  //   return {
  //     userId: "8710",
  //     auth: "Auth-NZG%3A977944ecf3665cf79730b518b9a3d68b"
  //   };
  // }
  var hash = window.location.hash;
  var urlArr = hash.split("?");
  if (urlArr.length <= 1) {
    return obj;
  }
  var paramStr = urlArr[1];
  if (paramStr.length > 1) {
    var arrPara = paramStr.split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null) {
        obj[arr[0]] = arr[1];
      }
    }
  }

  return obj;
}



// WEBPACK FOOTER //
// ./src/main.js